import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import CredibilityStrip from "@/components/landing/CredibilityStrip";
import Problem from "@/components/landing/Problem";
import Features from "@/components/landing/Features";
import HowItWorks from "@/components/landing/HowItWorks";
import AppPreview from "@/components/landing/AppPreview";
import Waitlist from "@/components/landing/Waitlist";
import Footer from "@/components/landing/Footer";
import { useReveal } from "@/components/landing/useReveal";

const Landing = () => {
  useReveal();
  return (
    <main data-testid="landing-page" className="min-h-screen bg-[#F5F0E8]">
      <Nav />
      <Hero />
      <CredibilityStrip />
      <Problem />
      <Features />
      <HowItWorks />
      <AppPreview />
      <Waitlist />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        richColors
        closeButton
        toastOptions={{
          style: {
            fontFamily: "DM Sans, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
